import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React, { forwardRef, useState, useRef } from 'react';
import { useTheme, jsx } from '@emotion/react';
import useId from '@indeed/ihl-use-id';
import { themed } from '@indeed/ifl-css';
import { matchesDisplayName } from '../../utils/displayName.js';
import { Tab } from './Tab.js';
import { TabList } from './TabList.js';
import { TabPanel } from './TabPanel.js';
import { TabPanels } from './TabPanels.js';
import { TabsContext } from './useTabContext.js';
import '../../utils/transition.js';
import '../../utils/createResponsive.js';
import '@indeed/ifl-icons';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../TouchTarget/TouchTarget.js';
import '../Box/Box.js';

const removeColons = str => str.replace(/:/g, "");
/**
 * Styles for Tabs
 */
const StyledTabs = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e1v394w80"
} : {
  styleProps: [],
  target: "e1v394w80",
  label: "StyledTabs"
})(() => ({
  inlineSize: "100%",
  fontFamily: "default"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/tabs
 */
const Tabs = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    onChange,
    defaultIndex,
    index,
    ...props
  } = _ref;
  const initialIndex = defaultIndex ?? 0;
  const [currentIndex, setIndex] = useState(index ? index : initialIndex);
  const size = useRef("md");
  const [full, setFull] = useState(false);
  const theme = useTheme();
  const defaultId = `ifl-Tabs-${useId()}`;
  const uid = props.id || defaultId;
  const onChangeHandler = onChange ? onChange : idx => {
    setIndex(idx);
  };
  const tabList = React.Children.toArray(children).filter(child => {
    return matchesDisplayName([TabList], child);
  })[0];
  const tabPanels = React.Children.toArray(children).filter(child => {
    return matchesDisplayName([TabPanels], child);
  })[0];
  const tabsIds = [];
  const panelsIds = [];
  let count = 0;
  if (tabList) {
    React.Children.map(tabList.props.children, child => {
      if (matchesDisplayName([Tab], child)) {
        tabsIds.push(child.props.id ?? child.props.id ? child.props.id : removeColons(`${uid}-ifl-Tab-${count}`));
        count += 1;
      }
    });
  }
  count = 0;
  if (tabPanels) {
    React.Children.map(tabPanels.props.children, child => {
      if (matchesDisplayName([TabPanel], child)) {
        panelsIds.push(child.props.id ?? child.props.id ? child.props.id : removeColons(`${uid}-ifl-TabPanel-${count}`));
        count += 1;
      }
    });
  }
  const context = {
    currentIndex: index ?? currentIndex,
    onChangeHandler,
    tabsIds,
    panelsIds,
    size,
    full,
    setFull,
    displayRTL: theme.direction === "rtl",
    uid
  };
  return jsx(TabsContext.Provider, {
    value: context
  }, jsx(StyledTabs, _extends({
    id: uid
  }, props, {
    ref: ref
  }), children));
});
Tabs.displayName = "Tabs";

export { StyledTabs, Tabs };
